const SWITCH_NAME = "flip-b5feeefaa14a84e2d4556adf7c4b54ff";

export const setSwitchCompanies = () => localStorage.setItem(SWITCH_NAME, true);

export const getSwitchCompanies = () => localStorage.getItem(SWITCH_NAME);

export const deleteSwitchCompanies = () => {
  if (localStorage.getItem(SWITCH_NAME)) localStorage.removeItem(SWITCH_NAME);
};
